class HighlightedGrid extends HTMLElement {
  constructor() {
    super();
  } 
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".review-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          grid: {
            rows: 2,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
            1441: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("highlighted-grid", HighlightedGrid);

class customreviews extends HTMLElement {
  constructor() {
    super();
  } 
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".review-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          grid: {
            rows: 2,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 24,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1441: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-reviews", customreviews);

class ProductSlider extends HTMLElement {
  constructor() {
    super();
  } 
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".new-product-slider",
        {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl:
              ".new-product-right-" + this.getAttribute("data-sectionid"),
            prevEl:
              ".new-product-left-" + this.getAttribute("data-sectionid"),
          },
          pagination: {
            el: ".product-pagination-" + this.getAttribute("data-sectionid"),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            }
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("new-product-slider", ProductSlider);

class ExpertSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      //-----------------------
      //  SWIPERS INITIALIZE
      //-----------------------

      const swiper = new Swiper(".video-content-slider", {
        spaceBetween: 10,
        slidesPerView: 1,
        watchSlidesProgress: true,
      });

      const swiper2 = new Swiper(".video-slider", {
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: {
          nextEl: ".new-product-right-" + this.getAttribute("data-sectionid"),
          prevEl: ".new-product-left-" + this.getAttribute("data-sectionid"),
        }
      });

      const swiper3 = new Swiper(".video-logo-slider", {
        spaceBetween: 10,
        slidesPerView: 1,
        watchSlidesProgress: true,
      });

      //-----------------------
      //  SYNC ALL 3 SLIDERS
      //-----------------------

      function syncAll(from, to1, to2) {
        to1.slideTo(from.activeIndex);
        to2.slideTo(from.activeIndex);
      }

      swiper.on('slideChange', () => syncAll(swiper, swiper2, swiper3));
      swiper2.on('slideChange', () => syncAll(swiper2, swiper, swiper3));
      swiper3.on('slideChange', () => syncAll(swiper3, swiper, swiper2));

      //-----------------------
      //  PAUSE VIDEOS ON SLIDE CHANGE
       //-----------------------

      const pauseVideosInSection = () => {
        this.querySelectorAll("video").forEach(video => video.pause());
        this.querySelectorAll(".play-pause-button").forEach(btn => btn.classList.remove("active"));
      };

      swiper.on("slideChange", pauseVideosInSection);
      swiper2.on("slideChange", pauseVideosInSection);
      swiper3.on("slideChange", pauseVideosInSection);

      //-----------------------
      // PLAY–PAUSE BUTTON LOGIC
      //-----------------------

      this.querySelectorAll('.play-pause-button').forEach(btn => {
      btn.addEventListener('click', function () {

        // find sibling video
        let video = this.parentElement.querySelector('video');
        if (!video) return;

        // Pause all OTHER videos in this section
        const allVideos = btn.closest('expert-section').querySelectorAll('video');
        const allButtons = btn.closest('expert-section').querySelectorAll('.play-pause-button');

        allVideos.forEach(v => {
          if (v !== video) v.pause();
        });

        allButtons.forEach(b => {
          if (b !== btn) b.classList.remove('active');
        });

        // Toggle clicked video
        if (video.paused) {
          video.play();
          this.classList.add('active');
        } else {
          video.pause();
          this.classList.remove('active');
        }
      });
    });


    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("expert-section", ExpertSection);


class NewCustomReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const lien = this.getAttribute("desktop-view");
    const rows = lien === "true" ? 1 : 2; // decide rows here
    const sectionId = this.getAttribute("data-sectionid");
    const center_slide = this.getAttribute("center-slide");
    const enable_center = center_slide === "true" ? true : false ;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);
      $(this).css({ opacity: "1" });

       const isDesktop = window.innerWidth >= 768;
       if(isDesktop ){

        const swiper = new Swiper(".review-slider--" + sectionId, {
          slidesPerView: 1,
          spaceBetween: 24,
          centeredSlides: enable_center,
          speed: 6000,
          autoplay: {
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: true 
          },
          loop: true,
          allowTouchMove: true,
          navigation: {
            nextEl: ".new-product-right-" + sectionId,
            prevEl: ".new-product-left-" + sectionId,
          },
          grid: {
            rows: 2,
          },
          pagination: {
            el: ".product-pagination-" + sectionId,
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 24,
              grid: {
                rows: 2,
              },
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
              grid: {
                rows: rows,
              },
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 24,
              grid: {
                rows: rows,
              },
            },
            1441: {
              slidesPerView: 3,
              spaceBetween: 24,
              grid: {
                rows: rows,
              },
            },
          },
        });
        
      }else{
        const swiper = new Swiper(".review-slider--" + sectionId, {
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: ".new-product-right-" + sectionId,
          prevEl: ".new-product-left-" + sectionId,
        },
        grid: {
          rows: 2,
        },
        pagination: {
          el: ".product-pagination-" + sectionId,
          clickable: true,
        },
        breakpoints: {
          560: {
            slidesPerView: 1,
            spaceBetween: 24,
            grid: {
              rows: 2,
            },
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
            grid: {
              rows: rows,
            },
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
            grid: {
              rows: rows,
            },
          },
          1441: {
            slidesPerView: 3,
            spaceBetween: 24,
            grid: {
              rows: rows,
            },
          },
        },
      });
      }
    };

    new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("new-custom-reviews", NewCustomReviews);


class ContactBannerSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".grid-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 24,
          loop: true,
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 24,
              loop: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
              loop: false,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 24,
              loop: false,
            },
            1100: {
              slidesPerView: 4,
              spaceBetween: 24,
              loop: false,
            },
            1441: {
              slidesPerView: 4,
              spaceBetween: 24,
              loop: false,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("contact-banner-section", ContactBannerSection);



class textwithgrid extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".grid-slider--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 24,
          loop: true,
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 24,
              loop: true,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 24,
              loop: false,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 24,
              loop: false,
            },
            1100: {
              slidesPerView: 4,
              spaceBetween: 24,
              loop: false,
            },
            1441: {
              slidesPerView: 4,
              spaceBetween: 24,
              loop: false,
            },
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("text-with-grid", textwithgrid);


class collectionsliderhome extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(this).css({ opacity: "1" });
      var swiper = new Swiper(
        ".collection-slider-home--" + this.getAttribute("data-sectionid"),
        {
          slidesPerView: 1,
          spaceBetween: 2,
          centeredSlides: true, 
          loop: true,
          navigation: {
            nextEl:
              ".swiper-button-next--" + this.getAttribute("data-sectionid"),
            prevEl:
              ".swiper-button-prev--" + this.getAttribute("data-sectionid"),
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 1,
              spaceBetween: 2,
              loop: true,
              centeredSlides: true, 
            },
            769: {
              slidesPerView: 2,
              spaceBetween: 16,
              loop: true,
              centeredSlides: false, 
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 24,
              centeredSlides: false, 
              loop: false,
            } 
          },
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("collection-slider-home", collectionsliderhome);

function isMobileDevice() {
  return window.innerWidth < 750;
}

class newproductgrid extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(this).css({ opacity: "1" });

      $(".product-media-slider").each(function () {
        const sectionId = $(this).attr("data-pid");
        const sliderSelector = ".product-media-slider--" + sectionId;
        const slider = document.querySelector(sliderSelector);

        if (!slider) {
          console.warn("Slider not found:", sliderSelector);
          return;
        }
        if (slider.classList.contains("swiper-initialized")) {
          return;
        }

        var swiper = new Swiper(sliderSelector, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            enabled: false,
            delay: 1000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination--" + sectionId,
            clickable: true,
            type: "bullets",
          },
          observer: true,
          observeParents: true,
          on: {
            init: function () {
              if (!isMobileDevice()) {
                // Use arrow function to capture the correct 'this' (swiper instance)
                slider.addEventListener("mouseenter", () => {
                  this.autoplay.start();
                });
                slider.addEventListener("mouseleave", () => {
                  this.autoplay.stop();
                });
              }
            },
          },
        });
      });

      var swiper = new Swiper(".grid-container-swiper-" + this.getAttribute("data-sectionid"), {
        slidesPerView: 2,
        spaceBetween: 24,
        navigation: {
          nextEl:
            ".swiper-button-next",
          prevEl:
            ".swiper-button-prev",
        },
      });
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("new-product-grid", newproductgrid);
